// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3Osqg","file":"styles_file__2dQsx"};